function injectStyle (ssrContext) {
  require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-06c75dfd\",\"scoped\":true,\"hasInlineConfig\":false}!../../vue-loader/lib/selector?type=styles&index=0!./crop.vue")
}
var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./crop.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-06c75dfd\"}!../../vue-loader/lib/selector?type=template&index=0!./crop.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06c75dfd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-core-image-upload/dist/crop.vue
// module id = 969
// module chunks = 1